import Box from "@mui/material/Box";

const CountChip = ({ value, color = "primary.main" }) => (
    <Box
        component="span"
        sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 22,
            height: 22,
            px: 0.75,
            borderRadius: 999,
            bgcolor: color,
            color: "#fff",
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1,
        }}
    >
        {value}
    </Box>
);

export default CountChip;
